
<script>

    export const randonneeItem = {
        data : function(){
            return {
                id:null,
            }
        },
        props : {
            title : String,
            distance : String,
            denivele : String,
            difficulty : String,
            content : String,
            visorando_url : String,
            geojson : Object,
        },
        render()
        {
            return (
                <li class="list-content">
                    <div class="list-item">
                        <div class="d-flex px-3"><div class="name-1" >{this.$props.title}</div></div>
                    <div class="infos d-flex"><div class="m-auto other"><img src={require('../assets/imgs/mountain.png')} width="25px" class="other"/>{this.$props.denivele}</div>
                            <div class="m-auto d-flex flex-row"> <img src={require('../assets/imgs/marche_white.png')}  class="other" width="25px"/>{this.$props.distance}</div>
                            <div class="m-auto other">{this.$props.difficulty}</div></div>
                </div>
                <div class="content">
                    <p>{this.$props.content}</p>
                        <div class="link"><img src={require("../assets/imgs/share.png")} width="25px" style="transform: scaleX(-1)" alt=""/><a  href={this.$props.visorando_url}>See on website</a></div>
                </div>
                </li>
            );
        },
    }

    export const randonneeList = {
        data : function(){
            return{
                cards : null,
                layers : null,
            }
        },
        mounted(){
            
        },

        render(){
            return(
                <ul class="list-container">
                    {this.$slots.default}
                </ul>
            )
        },
        methods: {
            inita : function(map, elements)
            {
                map.resize();
                 this.cards = elements
                
                this.layers = []
                let i = 0; 
                const mapDiv = document.getElementsByClassName('mapboxgl-canvas')[0];
                const target = document.body;



                 //listeners des cards
                const listener = function(map, element) {

                    this.cards.forEach((card) => {
                        if(card != element){
                           
                            let con = card.$el.children[1];
                            let inf = card.$el.children[0].children[1]
                            con.style.maxHeight = null;
                            inf.classList.remove('w-100');
                        }
                        
                    })
                    
                    const content = element.$el.children[1];
                    const infos = element.$el.children[0].children[1];
                    const height = (content.scrollHeight + content.children[1].scrollHeight).toString() + 'px';
                    //content.style.overflow = 'auto';
                    const a = this.layers;
                    this.layers.forEach((layer) => {
                        map.setLayoutProperty(layer, 'visibility', 'none' );
                    })
                    map.setLayoutProperty(element.id, 'visibility', 'visible');
                        var features = map.getSource(element.id)._options.data.features;
                        
                        const center = features[0].geometry.coordinates;
                        map.flyTo({
                            center: center
                        }); 

                    
                    infos.classList.toggle('w-100')
                    if (content.style.maxHeight){
                        content.style.maxHeight = null;
                    } else {
                        content.style.maxHeight = height;
                    }
                    map.resize();
                    
                }

          
                for(i = 0; i< this.cards.length;i++)
                {
                    const sl = 'source' + i.toString()
                    this.layers.push(sl);
                    this.cards[i].id = sl;
                    
                    this.AddSourceAndLayer(sl,this.cards[i].geojson, map);
                    this.cards[i].$el.addEventListener('click', listener.bind(this, map, this.cards[i]));
                   
                }




                

    
    
    
    
    //initialisation des listener pour les cartes




            },
            AddSourceAndLayer :function(sl, geojson, map)
            {
          
            map.addSource(sl,{
                    'type': 'geojson',
                    'data' : geojson
                                });
                    
            map.addLayer({
            'id': sl,
            'type': 'line',
            'source': sl,
            'layout': {
                'visibility' : 'none',
                'line-join': 'round',
                'line-cap': 'round',
                },
            'paint': {
            'line-color': '#ff6666',
            'line-width': 4
            },
            
            });
        },
        }
    }

    export default randonneeList;

</script>


<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,700;1,700&display=swap');


p {
    margin: 0;
}

.list-content {
    margin-right: auto;
    display: flex;
    flex-direction: column;
    pointer-events:all;
}

.content {
    max-height: 0;
    max-width: 23rem;
    padding: 0 18px;
    overflow: hidden;
    background-color: white;
    font-weight: 400;
    font-size: 0.75rem;

}

.link *{
    color: blue!important;
    font-weight: 400!important;
    font-size: 1.0rem;
    text-decoration: none;
    transition-duration: 0.2s;

}

.link a:hover {
    text-decoration: underline;
    color: blue!important;
}

@media (max-width: 750px)
{
    .container-r {
        width: 100%!important;
    }

    .list-container {
        justify-content: center;
        margin: auto!important;
    }

    .list-item {
        margin-right: auto!important;
        margin-left: auto!important;
    }

    .list-content {
        margin-right: auto!important;
        margin-left: auto!important;
    }
    .title {
        text-align: center!important;
    }
}

.title {
    padding: 1rem;
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
    font-size: 2rem;
    color: white;
    z-index: 1;
    text-align: left;
    text-shadow: 4px 4px 2px rgb(0, 0, 0);

}

.list-container {
    z-index: 1;
    margin: 0;
    display: flex;
    padding: 1rem;
    flex-direction: column;
}

.list-container * {
    font-family: 'Montserrat', sans-serif!important;
    font-weight: 600;
}

.name-1 {
    font-size: 1rem;
    padding-right: 6rem;
    margin: auto;
}

.infos * {
    cursor: pointer;
}

.infos {
    background-color: black;
    flex-direction: row;
    border-radius: 5rem;
    cursor: pointer;
    overflow: hidden;
    padding: 0 1.25rem;
    color: white;
    position: absolute;
    bottom: 0;
    right: 0;
    height:100% ;
    width: 6rem;
    transition: all 0.2s ease-in;
}



.infos:hover {
    width: 100%;
    
}

.w-100 .other {
    display: flex;
    flex-direction: row;
}

.other {
    display: none;
}

.infos:hover .other {
    display: flex;
    flex-direction: row;
}

.list-item {
border-radius: 5rem;
justify-content: space-between;
background-color: white;
display: flex;
min-height: 2.5rem;
margin: 0.5rem;
position: relative;
flex-direction: row;
min-width: 20rem;
max-width: 23rem;
box-shadow: 0px 0px 14px 0px rgba(0,0,0,0.57);
}

.container-r {
    display: flex;
    flex-direction: column;
    width: 50%;

}





</style>